import Model from './Model';

export default class FunnelAffiliate extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'funnel-affiliates';
  }
}
